import { type FormEvent, type ReactElement, useState } from 'react';
import { Button, FormField } from '@/shared/ui';
import { useRequestPasswordReset } from '../model/use-password-reset';
import { SUBMIT_BUTTON_CLASS, UNDERLINE_INPUT_CLASS } from './auth-form-styles';
import { SubmitArrow } from './submit-arrow';

/** 재설정 메일 요청 폼. (비밀번호를 잊은 상태 — 비로그인 접근) */
export const RequestPasswordResetForm = (): ReactElement => {
  const [email, setEmail] = useState('');
  const { emailError, formError, isPending, isDone, submit } = useRequestPasswordReset();

  if (isDone) {
    return (
      <p className="rounded-[1.25rem] bg-muted/60 p-5 text-[15px] text-muted-foreground">
        입력하신 주소로 재설정 메일을 보냈습니다. 계정이 없거나 이메일 인증 전이라면 메일이 오지
        않을 수 있습니다.
      </p>
    );
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    void submit(email);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-6" noValidate>
      <FormField
        label="가입한 이메일"
        type="email"
        autoComplete="email"
        isRequired
        className={UNDERLINE_INPUT_CLASS}
        value={email}
        error={emailError ?? undefined}
        onChange={(event) => setEmail(event.target.value)}
      />

      {formError ? (
        <p role="alert" className="text-sm text-destructive">
          {formError}
        </p>
      ) : null}

      <Button type="submit" isLoading={isPending} className={SUBMIT_BUTTON_CLASS}>
        재설정 메일 보내기
        <SubmitArrow />
      </Button>
    </form>
  );
};
